module.exports = __webpack_public_path__ + "static/media/HealthifyMe_logo.f1d7502b.png";